import { Box } from '@hopskipdrive/react-components';
import styled from 'styled-components';

import { colorPalette } from '../../../../shared/components/variables';

export const MBMCard = styled(Box)`
  background-color: ${colorPalette.red975};
  width: 100%;
  border-radius: 12px;
  border: 1px solid var(--border-main, ${colorPalette.neutral550});
  padding: 12px;
  gap: 18px;
`;
